<template>
  <div class="actual-msi-info-wrapper">
    <div class="actual-msi-info-container">
      <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
      <div class="spinner-container" v-if="isLoading">
        <base-spinner
          :is-loading="true"
          :is-local="true"
          class="spinner"
        />
      </div>
      <div v-if="!isLoading" class="actual-msi-info-form">
        <div class="field-container">
          <base-text-input
            :default-value="fullName"
            :label="$t('message.settingsPage.actualizeDataViaMsi.fields.fullName')"
            :name="'fullName'"
            :disabled="true"
            :is-has-error-block="false"
            v-model="fullName"
          />
        </div>
        <div class="field-container">
          <base-text-input
            :default-value="idDocumentSeriesNumber"
            :label="$t('message.settingsPage.actualizeDataViaMsi.fields.idDocumentSeriesNumber')"
            :name="'idDocumentSeriesNumber'"
            :disabled="true"
            :is-has-error-block="false"
            v-model="idDocumentSeriesNumber"
          />
        </div>
        <div class="field-container">
          <base-text-input
            :default-value="phoneNumber"
            :label="$t('message.settingsPage.actualizeDataViaMsi.fields.phoneNumber')"
            :name="'phoneNumber'"
            :disabled="true"
            :is-has-error-block="false"
            v-model="phoneNumber"
          />
        </div>
        <div class="field-container textarea-field">
          <base-textarea-input
            :default-value="registrationAddress"
            :label="$t('message.settingsPage.actualizeDataViaMsi.fields.registrationAddress')"
            :name="'registrationAddress'"
            :disabled="true"
            v-model="registrationAddress"
          />
        </div>
        <div class="btns-block">
          <div class="btn-container">
            <base-button
              :text="$t('message.settingsPage.actualizeDataViaMsi.cancelBtn')"
              class="cancel-btn"
              @click="declineActualMsiInfo()"
            />
          </div>
          <div class="btn-container">
            <base-button
              :text="$t('message.settingsPage.actualizeDataViaMsi.saveBtn')"
              @click="approveActualMsiInfo()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '../../../components/base/BaseButton.vue';
import BaseSpinner from '../../../components/base/BaseSpinner.vue';
import BaseTextInput from '../../../components/base/BaseTextInput.vue';
import BaseTextareaInput from '../../../components/base/BaseTextareaInput.vue';

export default {
  name: 'ActualMsiInfo',
  inject: ['$httpService'],
  components: {
    BaseButton,
    BaseSpinner,
    BaseTextInput,
    BaseTextareaInput
  },
  data() {
    return {
      isLoading: true,
      actualizationToken: '',
      fullName: '',
      idDocumentSeriesNumber: '',
      phoneNumber: '',
      registrationAddress: ''
    };
  },
  async created() {
    const { code } = this.$route.query;

    if (!code) {
      this.$router.push({ name: 'settings' });
      return;
    }

    try {
      const response = await this.$httpService.auth.getActualMsiInfo({ code });
      this.actualizationToken = response.data.actualization_token || '';
      this.parseQuestionnaire(response.data.questionnaire);
      this.isLoading = false;
    } catch (error) {
      this.$router.push({ name: 'settings' });
    }
  },
  methods: {
    parseQuestionnaire(questionnaire) {
      const data = questionnaire || {};
      const fullName = data.full_name || {};
      const idDocument = data.id_document || {};
      const phoneNumber = data.phone_number || {};
      const registrationAddress = data.registration_address || {};

      this.fullName = fullName.actual || '';
      this.idDocumentSeriesNumber = idDocument.actual_series_number || '';
      this.phoneNumber = phoneNumber.actual || '';
      this.registrationAddress = registrationAddress.actual || '';
    },
    async approveActualMsiInfo() {
      await this.sendActualMsiInfoDecision(() => {
        return this.$httpService.auth.approveActualMsiInfo({
          token: this.actualizationToken,
          decision: 'approve'
        });
      }, true);
    },
    async declineActualMsiInfo() {
      await this.sendActualMsiInfoDecision(() => {
        return this.$httpService.auth.declineActualMsiInfo({
          token: this.actualizationToken,
          decision: 'decline'
        });
      });
    },
    async sendActualMsiInfoDecision(request, shouldShowSuccessToast) {
      try {
        await request();

        if (shouldShowSuccessToast) {
          this.$toast.success(this.$t('message.settingsPage.actualizeDataViaMsi.saveSuccess'));
        }

        this.$router.push({ name: 'settings' });
      } catch (error) {
        this.$router.push({ name: 'settings' });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.actual-msi-info-wrapper {
  @include page-wrapper-with-header-and-footer;

  padding-top: 20px;
  box-sizing: border-box;
}

.actual-msi-info-container {
  width: 95%;
  min-height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
}

.route-name {
  @include route-name;

  margin-bottom: 15px;
}

.spinner-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10%;
}

.spinner ::v-deep {
  width: 100%;
}

.actual-msi-info-form {
  width: 100%;
  max-width: 520px;
  display: flex;
  flex-direction: column;
}

.field-container {
  width: 100%;
}

.field-container ::v-deep .input-label {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #7A7A7A;
}

.field-container ::v-deep .input-block {
  height: 40px;
  min-height: 40px;
  border-radius: 6px;
}

.field-container ::v-deep .input {
  height: 38px;
  min-height: 38px;
  padding: 8px;
  font-size: 14px;
  line-height: 24px;
  color: #01273B;
}

.field-container ::v-deep .input:disabled {
  background-color: rgba(239, 239, 239, 0.3);
  cursor: default;
}

.textarea-field ::v-deep .input-block {
  height: 86px;
  min-height: 86px;
}

.textarea-field ::v-deep .input {
  height: 100%;
  min-height: 100%;
  padding-top: 8px;
  resize: none;
}

.textarea-field ::v-deep .error-block {
  display: none;
}

.btns-block {
  display: flex;
  margin-top: 20px;
  margin-bottom: 50px;
}

.btn-container {
  width: 200px;
  height: 40px;
}

.btn-container:first-of-type {
  margin-right: 20px;
}

.btn-container ::v-deep .button {
  min-height: 40px;
  max-height: 40px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 24px;
}

.cancel-btn ::v-deep {
  background-color: white;
  color: #41BF7B;
  border: 2px solid #41BF7B;

  &:hover {
    color: white;
  }
}

@media screen and (max-width: 1155px) {
  .actual-msi-info-wrapper {
    padding-top: 40px;
  }

  .actual-msi-info-container {
    @include base-page-container;

    align-items: flex-start;
    padding-top: 0;
  }
}

@media screen and (max-width: 700px) {
  .btns-block {
    flex-direction: column;
    gap: 12px;
  }

  .btn-container {
    width: 100%;
  }

  .btn-container:first-of-type {
    margin-right: 0;
  }
}
</style>
